import { Inject } from '@odinjs/odin';
import { HtmlViewerAPI } from '@philips-internal/customer-portal-components/src/components';
import { CheckboxAPI, FetchAPI, ModalService } from '@philips-internal/oswald-ui-components';
import Controller, { OnCancel, OnMount, OnSubmit } from '@philips-internal/oswald-ui-core/lib/client';

import { FragmentNames, TermUseAliases } from '../codegen';
import { Term, TermService, TermType } from '../services';

import BaseController from './BaseController';

export const SYNC_TERMS_DIALOG_ID = 'sync-terms-dialog';

@Controller({ fragment: FragmentNames.TERM_USE })
class TermUseController extends BaseController {

  @Inject(TermUseAliases.CHECKBOX_AGREE)
  checkboxAgree!: CheckboxAPI;

  @Inject(TermUseAliases.HTML_VIEWER_TERM_USE)
  htmlViewerTermUse!: HtmlViewerAPI;

  @Inject(TermUseAliases.FETCH_TERM_USE)
  fetchTermUse!: FetchAPI;

  @OnMount({ target: TermUseAliases.FETCH_TERM_USE })
  onMountFetchTermUse(): void {
    const type = this.context.get('type');
    this.fetchTermUse.setParameters({ type });
  }

  @OnSubmit({ target: TermUseAliases.FORM_TERM_USE })
  onSubmitFormTermUse(): void {
    if (this.checkboxAgree.getValue()) {
      const type = (this.context.get('type') as TermType);
      const term = (this.htmlViewerTermUse.getData() as Term);
      void TermService.updateRead(type, term.termId)
        .then((response) => {
          if (response) {
            this.onCancelFormTermUse();
          }
        });
    }
  }

  @OnCancel({ target: TermUseAliases.FORM_TERM_USE })
  onCancelFormTermUse(): void {
    ModalService.close(SYNC_TERMS_DIALOG_ID);
  }

}

export default TermUseController;
